import * as angular from "angular";
import {IController} from "angular";

export class transactionDescriptionCtrl implements IController {

  deliveryId: any;
  description: any;

  private start: any;
  private end: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    const idIndex = this.description.indexOf(this.deliveryId);
    this.start = this.description.slice(0, idIndex);
    this.end = this.description.slice(idIndex + this.deliveryId.length);
  };

  $onChanges(changes) {
    if (changes.deliveryId && !changes.deliveryId.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('transactionDescription', {
    bindings: {
      deliveryId: '<',
      description: '<'
    },
    template: require('./transaction-description.html').default,
    controller: transactionDescriptionCtrl
  });
